import React from 'react';
import { Box, CircularProgress } from '@mui/material';

interface LoadingIndicatorProps {
    minHeight?: number | string;
}

const LoadingIndicator = ({
    minHeight = 'calc(100vh - 160px)',
}: LoadingIndicatorProps) => (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight,
            width: '100%',
        }}
    >
        <CircularProgress />
    </Box>
);

export default LoadingIndicator;
